import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { LockKeyhole } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("ra_token", data.access_token);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-ink flex items-center justify-center px-6">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        className="w-full max-w-sm"
      >
        <div className="text-center mb-8">
          <img src="/logo.png" alt="RightAccount — Счетоводна кантора" className="h-14 w-auto mx-auto mb-4" />
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-dim">Административен вход</p>
        </div>

        <form data-testid="admin-login-form" onSubmit={submit} className="border border-line bg-coal p-8 flex flex-col gap-5">
          <div className="flex justify-center text-gold mb-2">
            <LockKeyhole size={22} strokeWidth={1.5} />
          </div>
          {error && (
            <p data-testid="login-error-message" className="text-red-400 text-sm border border-red-400/30 bg-red-400/10 px-4 py-3">
              {error}
            </p>
          )}
          <div>
            <label htmlFor="login-email" className="block font-mono text-[11px] uppercase tracking-[0.25em] text-dim mb-2">Имейл</label>
            <input
              id="login-email"
              data-testid="login-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-ink border border-line text-mist px-4 py-3 text-sm outline-none focus:border-gold transition-colors duration-300"
            />
          </div>
          <div>
            <label htmlFor="login-password" className="block font-mono text-[11px] uppercase tracking-[0.25em] text-dim mb-2">Парола</label>
            <input
              id="login-password"
              data-testid="login-password-input"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-ink border border-line text-mist px-4 py-3 text-sm outline-none focus:border-gold transition-colors duration-300"
            />
          </div>
          <button
            data-testid="login-submit-button"
            type="submit"
            disabled={loading}
            className="bg-gold text-ink py-3.5 text-sm font-medium tracking-wide hover:bg-gold-light transition-colors duration-300 disabled:opacity-60"
          >
            {loading ? "Влизане…" : "Вход"}
          </button>
        </form>

        <p className="text-center mt-6">
          <Link to="/" data-testid="login-back-link" className="text-dim text-xs hover:text-gold transition-colors duration-300">
            ← Обратно към сайта
          </Link>
        </p>
      </motion.div>
    </div>
  );
}
